import { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select, { type SelectOption } from "../../../components/ui/Select";

interface BulkActionsProps {
	selectedCount: number;
	onBulkAction: (action: string) => void;
	onClearSelection: () => void;
}

const BULK_ACTIONS: SelectOption[] = [
	{ value: "export", label: "Export Selected" },
	{ value: "delete", label: "Delete Selected" },
];

const BulkActions: React.FC<BulkActionsProps> = ({
	selectedCount,
	onBulkAction,
	onClearSelection,
}) => {
	const [selectedAction, setSelectedAction] = useState<string>("");

	const handleExecuteAction = () => {
		if (selectedAction && onBulkAction) {
			onBulkAction(selectedAction);
			setSelectedAction("");
		}
	};

	return (
		<div className="bg-primary/5 border-l-4 border-primary rounded-lg p-4">
			<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0">
				<div className="flex items-center space-x-3">
					<div className="flex items-center space-x-2">
						<Icon name="CheckSquare" size={20} className="text-primary" />
						<span className="font-medium text-foreground">
							{selectedCount} payment{selectedCount !== 1 ? "s" : ""} selected
						</span>
					</div>

					<Button
						variant="ghost"
						size="sm"
						onClick={onClearSelection}
						className="text-muted-foreground hover:text-foreground"
					>
						<Icon name="X" size={16} className="mr-1" />
						Clear
					</Button>
				</div>

				<div className="flex items-center space-x-3 w-full sm:w-auto">
					<Select
						value={selectedAction}
						options={BULK_ACTIONS}
						onValueChange={(value) => setSelectedAction(value as string)}
						placeholder="Choose action..."
					/>

					<Button
						onClick={handleExecuteAction}
						disabled={!selectedAction}
						className="flex items-center space-x-2 whitespace-nowrap"
					>
						{selectedAction && <Icon name="Play" size={16} />}
						<span>Execute</span>
					</Button>
				</div>
			</div>

			{/* Quick Actions */}
			<div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-primary/20">
				<Button
					variant="outline"
					size="sm"
					onClick={() => onBulkAction("export")}
					className="flex items-center space-x-2 text-xs"
				>
					<Icon name="Download" size={14} />
					<span>Export Selected</span>
				</Button>

				<Button
					variant="outline"
					size="sm"
					onClick={() => onBulkAction("delete")}
					className="flex items-center space-x-2 text-xs text-destructive hover:text-destructive"
				>
					<Icon name="Trash2" size={14} />
					<span>Delete Selected</span>
				</Button>
			</div>
		</div>
	);
};

export default BulkActions;
